import { securedAxiosAPI, basicAxios } from 'utils/axios';
import { store } from '../../store';

const securedRoute = {
    addBranch: 'branch/add',
    byPagination: 'branch/branchByPagination',
    allBranch: 'branch',
    base: 'branch',
    dynamicFilter: '/branch/dynamicFilter',
    addBranchAddress: '/branch/add-address',
    updateBranchAddress: '/branch/update-address',
    getBranchAddress: '/branch/branch-address'
};
const unsecureRoute = {
    getBranchById: 'branch'
};

export const getBranchById = async (id) => {
    const res = await basicAxios.get(`${unsecureRoute?.getBranchById}/${id}`);
    return res.data[0];
};

export const getAllBranches = async (isManagement = false, includeInactive = false) => {
    const params = new URLSearchParams();
    if (isManagement) params.append('is_management', 'true');
    if (includeInactive) params.append('include_inactive', 'true');
    const queryString = params.toString();
    const url = queryString ? `${securedRoute?.allBranch}?${queryString}` : `${securedRoute?.allBranch}`;
    const res = await securedAxiosAPI.get(url);
    return res.data;
};

export const getBranchByPagination = async () => {
    const { getState } = store;
    const { page, rowsPerPage } = getState().branch || {};
    const res = await securedAxiosAPI.post(securedRoute?.byPagination, { page: page || 0, rowsPerPage: rowsPerPage || 25 });
    return res.data;
};

export const addNewBranch = async (data) => {
    let payload = data;
    if (data?.branch_logo instanceof File || data?.logo instanceof File) {
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            if (data[key] !== null && data[key] !== undefined) {
                formData.append(key, data[key]);
            }
        });
        payload = formData;
    }
    const res = await securedAxiosAPI.post(securedRoute?.addBranch, payload);
    return res.data;
};

export const getBranchDetails = async (data) => {
    const res = await securedAxiosAPI.get(`${securedRoute?.base}/${data}`);
    return res.data[0];
};

export const deleteBranch = async (data) => {
    const res = await securedAxiosAPI.delete(`${securedRoute?.base}/${data}`);
    return res.data[0];
};

export const dynamicFilterBranch = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.dynamicFilter, data);
    return res.data;
};

export const addBranchAddress = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.addBranchAddress, data);
    return res.data;
};

export const updateBranchAddress = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.updateBranchAddress, data);
    return res.data;
};

export const branchAddressList = async (branchId) => {
    const res = await securedAxiosAPI.get(`${securedRoute?.getBranchAddress}?branchId=${branchId}`);
    return res.data;
};

export const getBranchUsers = async (branchId) => {
    const res = await securedAxiosAPI.get(`userMaster/branch-users/${branchId}`);
    return res.data;
};
